import {Button, Checkbox, FormControlLabel, Grid2} from "@mui/material";
import DateInterval from "components/common/form/DateInterval";
import CompanySelect from "components/global/CompanySelect";
import ReviewStatusTypesSelect from "components/global/ReviewStatusTypesSelect";
import UserSelect from "components/global/UserSelect";
import PropTypes from "prop-types";
import React from "react";

class ReviewUserForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filmCompanies: [],
        };

    }

    componentDidMount() {
        this.props.runSearch();
    }

    onChangeCompanies = (value) => {
        this.props.onChangeForm({
            companies: value,
        });
    };

    onChangeReviewStatus = (value) => {
        this.props.onChangeForm({
            statuses: value,
        });
    };
    onChangeUsers = (value) => {
        this.props.onChangeForm({
            users: value,
        });
    };

    onChangeInterval = (dateInterval) => {
        this.props.onChangeForm({ dateInterval });
    };
    handleSearch = () => {
        this.props.runSearch();
    };
    handleClear = () => {
        this.props.clearForm();
    };

    handleCountAllVersions = (e) => {
        this.props.onChangeForm({
            countAllVersions: e.target.checked,
        });
    };
    render() {
        const {
            form: { dateInterval, companies, users, statuses, countAllVersions }
        } = this.props;

        return (
            (<Grid2 container spacing={2}>
                <DateInterval defaultValue={dateInterval} onChange={this.onChangeInterval} />
                <Grid2
                    size={{
                        sm: 12,
                        xs: 12,
                        md: 6,
                        lg: 6,
                        xl: 6
                    }}>
                    <UserSelect defaultValue={users} placeholder={"All users"} multiple onChange={this.onChangeUsers} />
                </Grid2>
                <Grid2
                    size={{
                        sm: 12,
                        xs: 12,
                        md: 6,
                        lg: 6,
                        xl: 6
                    }}>
                    <CompanySelect
                        defaultValue={companies}
                        multiple
                        placeholder={"All companies"}
                        onChange={this.onChangeCompanies}
                    />
                </Grid2>
                <Grid2
                    size={{
                        sm: 12,
                        xs: 12,
                        md: 6,
                        lg: 6,
                        xl: 6
                    }}>
                    <ReviewStatusTypesSelect
                        defaultValue={statuses}
                        placeholder={"All status"}
                        multiple
                        onChange={this.onChangeReviewStatus}
                    />
                </Grid2>
                <Grid2 size={12}>
                    <FormControlLabel
                        control={<Checkbox checked={countAllVersions} onChange={this.handleCountAllVersions}  />}
                        label={"Count Revisions"}
                    />
                </Grid2>
                <Grid2 size={12}>
                    <Button
                        onClick={this.handleSearch}
                        color={"secondary"}
                        style={{ marginRight: 20 }}
                        size={"small"}
                        variant={"contained"}
                    >
                        Search
                    </Button>
                    <Button size={"small"} onClick={this.handleClear} variant={"contained"}>
                        Clear{" "}
                    </Button>
                </Grid2>
            </Grid2>)
        );
    }
}
export default ReviewUserForm;

ReviewUserForm.propTypes = {
    form: PropTypes.object.isRequired,
    onChangeForm: PropTypes.func.isRequired,
    runSearch: PropTypes.func.isRequired,
    clearForm: PropTypes.func.isRequired,
};
